// ═══════════════════════════════════════════════════════
// GESTION PROFIL UTILISATEUR (localStorage)
// ═══════════════════════════════════════════════════════

const CLE_PROFIL = "geo5_profil_utilisateur";
const CLE_SESSION = "geo5_session_active";

// Efface le profil au 1er lancement de chaque session navigateur
// sessionStorage est vidé à chaque fermeture d'onglet → popup réapparaît
const chargerProfil = () => {
  try {
    const sessionOuverte = sessionStorage.getItem(CLE_SESSION);
    if (!sessionOuverte) {
      // Nouvelle session → effacer le profil pour forcer le popup
      localStorage.removeItem(CLE_PROFIL);
      sessionStorage.setItem(CLE_SESSION, "1");
      return null;
    }
    return JSON.parse(localStorage.getItem(CLE_PROFIL) || "null");
  } catch { return null; }
};

const sauvegarderProfil = (p) => {
  try {
    localStorage.setItem(CLE_PROFIL, JSON.stringify(p));
    sessionStorage.setItem(CLE_SESSION, "1");
  } catch {}
};

export { chargerProfil, sauvegarderProfil };
